import React, { Component } from 'react'
import styled from 'styled-components'
import MapContainer from './containers/MapContainer'
import SearchResults from './containers/SearchResults'
import Filters from './containers/Filters'
import Search from './containers/Search'
import Title from './components/Title'
import { colors } from '../search-common/settings'

/**
 * The application container.
 */
class App extends Component {
  /**
   * Constructor
   *
   * @param {object} props
   */
  constructor( props ) {
    super( props )

    this.state = {
      showMap: false
    }

    this.setMapView = this.setMapView.bind( this )
  }

  /**
   * Function to toggle map view.
   */
  setMapView( showMap ) {
    this.setState({
      showMap: showMap
    })
  }

  /**
   * Render method.
   */
  render() {
    const { showMap } = this.state
    return (
      <BackgroundContainer>
        <Container>
          <Title />
          <FiltersContainer>
            <Filters />
          </FiltersContainer>
          <SearchContainer>
            <Search setMapView={this.setMapView} showMap={showMap} />
            <MapContainer showMap={showMap} />
            { !showMap && <SearchResults /> }
          </SearchContainer>
        </Container>
      </BackgroundContainer>
    )
  }
}

const BackgroundContainer = styled.div`
  background-color:${colors.grayTone1};
  margin: auto;
`

const Container = styled.div`
  max-width: 1440px;
  margin: auto;
`

const FiltersContainer = styled.div`
  flex-basis: 450px;
  background-color:${colors.grayTone1};
`
const SearchContainer = styled.div`
  background-color:${colors.grayTone1};
`

export default App
